import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const generateOtpForRegistration = createAsyncThunk(
  'otp/generateForRegistration',
  async (phone: string, { rejectWithValue }) => {
    try {
      const response = await api.post(`/identification/otp/generate/${phone}`);
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const generateOtpForVerification = createAsyncThunk(
  'otp/generateForVerification',
  async ({ phone, token }: { phone: string; token: string }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };

      const response = await api.post(
        `/identification/otp/generate-for-verification/${phone}`,
        undefined,
        {
          headers,
        }
      );
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
